"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._ValidateOfflineFunnelStartDate = exports._GetContractDate = exports._CreateBaseContract = void 0;
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var date_helper_const_1 = require("./date-helper.const");
var error_helper_const_1 = require("./error-handling/error-helper.const");
var input_output_helper_const_1 = require("./input-output-helper.const");
var input_mapping_const_1 = require("./input.mapping.const");
var _CreateBaseContract = function (contractOverwrite) {
    if (contractOverwrite === void 0) { contractOverwrite = {}; }
    var freeModules = [], paidModules = [];
    if (localStorage.getItem('selectableModules')) {
        freeModules = JSON.parse(localStorage.getItem('selectableModules')).map(function (a) { return ({
            id: a,
        }); });
    }
    if (localStorage.getItem('optionalModules')) {
        paidModules = JSON.parse(localStorage.getItem('optionalModules')).map(function (a) { return ({
            id: a,
        }); });
    }
    var contract = {
        selectedRateBundleModules: freeModules,
        optionalRateBundleTermModules: paidModules,
        rateBundleTermId: +(0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.rateBundleTermId),
        startDate: (0, exports._GetContractDate)(input_mapping_const_1._AllMappings.rateBundleStartDate),
        preuseDate: (0, exports._GetContractDate)(input_mapping_const_1._AllMappings.preuseDate),
    };
    var returnValue = lodash_1.default.cloneDeep(lodash_1.default.merge(contract, contractOverwrite));
    return returnValue;
};
exports._CreateBaseContract = _CreateBaseContract;
var _GetContractDate = function (mappingKey) {
    var field = (0, input_output_helper_const_1._ReadFieldValue)(mappingKey);
    if (new Date(field) < new Date() || field === '') {
        //if localstorage is outdated (in the past) we use today as backup cause ML fails otherwise
        field = (0, date_helper_const_1._GetTodaysDateAsISOString)();
    }
    return field;
};
exports._GetContractDate = _GetContractDate;
var _ValidateOfflineFunnelStartDate = function (contract, offerings) {
    var _a, _b, _c;
    var startDateDayField = (0, cash_dom_1.default)("[data-get=\"".concat(input_mapping_const_1._AdditionalContractFieldsMapping.contractStartDateDay.uid, "\"]"));
    var startDateMonthField = (0, cash_dom_1.default)("[data-get=\"".concat(input_mapping_const_1._AdditionalContractFieldsMapping.contractStartDateMonth.uid, "\"]"));
    var startDateYearField = (0, cash_dom_1.default)("[data-get=\"".concat(input_mapping_const_1._AdditionalContractFieldsMapping.contractStartDateYear.uid, "\"]"));
    // if any field is not existend, we do not validate any
    if (!(startDateDayField === null || startDateDayField === void 0 ? void 0 : startDateDayField.length) || !(startDateMonthField === null || startDateMonthField === void 0 ? void 0 : startDateMonthField.length) || !(startDateYearField === null || startDateYearField === void 0 ? void 0 : startDateYearField.length)) {
        return true;
    }
    var rawDay = ((_a = startDateDayField.val()) !== null && _a !== void 0 ? _a : '').toString().trim();
    var rawMonth = ((_b = startDateMonthField.val()) !== null && _b !== void 0 ? _b : '').toString().trim();
    var rawYear = ((_c = startDateYearField.val()) !== null && _c !== void 0 ? _c : '').toString().trim();
    console.log('raw contract start data', rawDay, rawMonth, rawYear);
    // allow not setting any field, this will mean it uses the default contract start date
    if (rawDay === '' && rawMonth === '' && rawYear === '')
        return true;
    var isNumeric = function (val) { return /^\d+$/.test(val); };
    // Check that all three are filled and numeric
    var fields = [
        { field: startDateDayField, value: rawDay },
        { field: startDateMonthField, value: rawMonth },
        { field: startDateYearField, value: rawYear },
    ];
    // check if every field is filled, if not show error
    var allValid = fields.every(function (_a) {
        var field = _a.field, value = _a.value;
        if (!isNumeric(value)) {
            (0, error_helper_const_1._AddErrorToDomObject)(field, translation_1.default.t('This is required'));
            return false;
        }
        (0, error_helper_const_1._RemoveStatusFromDomObject)(field);
        return true;
    });
    if (!allValid)
        return false;
    var day = parseInt(rawDay, 10);
    var month = parseInt(rawMonth, 10);
    var year = parseInt(rawYear, 10);
    // Basic range checks (optional but sane)
    if (year < 1900 ||
        month < 1 ||
        month > 12 ||
        day < 1 ||
        day > 31 // you can make this more strict if you want
    ) {
        (0, error_helper_const_1._AddErrorToDomObject)(startDateDayField, translation_1.default.t('This is required'));
        return false;
    }
    var dayStr = day.toString().padStart(2, '0');
    var monthStr = month.toString().padStart(2, '0');
    var yearStr = year.toString(); // YYYY
    var dateStr = "".concat(yearStr, "-").concat(monthStr, "-").concat(dayStr); // yyyy-mm-dd
    // Set contract start date
    contract.startDate = dateStr;
    // topfit has an opening of a new studio and the start is in the future but preuse today. So I commented this out. 
    // Benny mentioned that this should be how it is (preuse date of the contract data from ML should be taken)
    // contract.preuseDate = dateStr; 
    var offer = offerings.offerings.find(function (o) { var _a; return (_a = o.terms) === null || _a === void 0 ? void 0 : _a.find(function (t) { var _a; return t.id.toString() === ((_a = contract.rateBundleTermId) === null || _a === void 0 ? void 0 : _a.toString()); }); });
    if ((offer === null || offer === void 0 ? void 0 : offer.preuseType) === "NONE") {
        contract.preuseDate = dateStr;
    }
    return true;
};
exports._ValidateOfflineFunnelStartDate = _ValidateOfflineFunnelStartDate;
